import { apiSlice } from '../app/api/apiSlice';

// SHI-345: admin manual-orders, mirrors externalOrdersApiSlice but hits the /manual-order*
// endpoints (gated server-side to the 'riise' API key).
export const manualOrdersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getManualOrders: builder.query({
      query: ({ page = 1, limit = 10, search = '', status = '' } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        if (search) params.append('search', search);
        if (status) params.append('status', status);

        return {
          url: `manual-order${params.toString() ? `?${params.toString()}` : ''}`,
          headers: {
            'x-api-key': 'riise',
          },
        };
      },
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    updateManualOrderStatus: builder.mutation({
      query: (payload) => ({
        url: `manual-order/update-status`,
        method: 'PATCH',
        body: { ...payload },
        headers: {
          'x-api-key': 'riise',
        },
      }),
    }),
    bulkUpdateManualOrderStatuses: builder.mutation({
      query: (payload) => ({
        url: `manual-order/bulk-status-update`,
        method: 'POST',
        body: { ...payload },
        headers: {
          'x-api-key': 'riise',
        },
      }),
    }),
    createManualLabel: builder.mutation({
      query: (payload) => ({
        url: `manual-order/shipment`,
        method: 'POST',
        body: { ...payload },
        headers: { 'x-api-key': 'riise' },
      }),
    }),
    validateManualLabel: builder.mutation({
      query: (payload) => ({
        url: `manual-order/validate-dhl-shipments`,
        method: 'POST',
        body: { ...payload },
        headers: { 'x-api-key': 'riise' },
      }),
    }),
    updateBulkManualOrderStatusesTracking: builder.mutation({
      query: (payload) => ({
        url: `manual-order/bulk-status-tracking`,
        method: 'POST',
        body: { ...payload },
        headers: { 'x-api-key': 'riise' },
      }),
    }),
    getManualOrdersShipmentTracking: builder.query({
      query: (trackingIds) => ({
        url: `manual-order/dhl-shipments?trackingIds=${trackingIds}`,
        headers: { 'x-api-key': 'riise' },
      }),
      validateStatus: (response, result) => response.status === 200 && !result.isError,
    }),
    updateManualOrdersBulkStatusesFromDhl: builder.mutation({
      query: (payload) => ({
        url: `manual-order/bulk-status-update-dhl`,
        method: 'POST',
        body: { ...payload },
        headers: { 'x-api-key': 'riise' },
      }),
    }),
    sendManualOrderEmailUpdates: builder.mutation({
      query: (payload) => ({
        url: `manual-order/email-shipment-updates`,
        method: 'POST',
        body: { ...payload },
        headers: { 'x-api-key': 'riise' },
      }),
    }),
  }),
});

export const {
  useGetManualOrdersQuery,
  useUpdateManualOrderStatusMutation,
  useBulkUpdateManualOrderStatusesMutation,
  useCreateManualLabelMutation,
  useValidateManualLabelMutation,
  useUpdateBulkManualOrderStatusesTrackingMutation,
  useGetManualOrdersShipmentTrackingQuery,
  useLazyGetManualOrdersShipmentTrackingQuery,
  useUpdateManualOrdersBulkStatusesFromDhlMutation,
  useSendManualOrderEmailUpdatesMutation,
} = manualOrdersApiSlice;
